import { render, staticRenderFns } from "./AutoResizeTextarea.vue?vue&type=template&id=feb10628&scoped=true&"
import script from "./AutoResizeTextarea.vue?vue&type=script&lang=ts&"
export * from "./AutoResizeTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./AutoResizeTextarea.vue?vue&type=style&index=0&id=feb10628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb10628",
  null
  
)

export default component.exports